import { render, staticRenderFns } from "./Manner.vue?vue&type=template&id=52a04fa5&scoped=true"
var script = {}
import style0 from "./Manner.vue?vue&type=style&index=0&id=52a04fa5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a04fa5",
  null
  
)

export default component.exports